import React from "react";
import type { ComponentProps } from "react";

import type { PolicyMetaData } from "@/core/types";
import { Link2 } from "@/ui2/atoms/Link";
import { cn } from "@/lib/helpers/cn";
import { getVersionedConsentHref } from "@/lib/helpers/getVersionedConsentHref";
import { getCurrentPolicyVersion } from "@/lib/helpers/getCurrentPolicyVersion";

type DisclaimerProps = ComponentProps<"p"> & {
  policyMetadata: PolicyMetaData;
  customDisclaimerPrefix?: string;
};

export function ConsentDisclaimer({
  className,
  policyMetadata,
  customDisclaimerPrefix = null,
}: DisclaimerProps) {
  const disclaimerPrefix =
    customDisclaimerPrefix || "By creating your account, you agree to aptihealth's";

  return (
    <p className={cn("body-sm tw:text-center", className)}>
      {disclaimerPrefix}{" "}
      <ConsentLink
        policy="eula"
        text="Terms and Conditions of Use"
        version={getCurrentPolicyVersion({ policyMetadata, policy: "TERMS_AND_CONDITIONS" })}
      />
      ,{" "}
      <ConsentLink
        policy="privacy"
        text="Privacy Policy"
        version={getCurrentPolicyVersion({ policyMetadata, policy: "PRIVACY" })}
      />
      , and{" "}
      <ConsentLink
        policy="hipaa"
        text="HIPAA Notice of Privacy Practices"
        version={getCurrentPolicyVersion({ policyMetadata, policy: "HIPAA" })}
      />{" "}
    </p>
  );
}

type ConsentLinkProps = Parameters<typeof getVersionedConsentHref>[0] & {
  text: string;
};

function ConsentLink({ text, policy, version }: ConsentLinkProps) {
  return (
    <Link2 href={getVersionedConsentHref({ policy, version })} isExternal>
      {text}
    </Link2>
  );
}
